import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IDataAlertInfo } from '../../../../ts/models/IDataAlertInfo';
import { dataAlertEdit } from '../../../actions/spaces/DataAlertMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isAlertSuspended, isEditOrResumeEnabled } from './IEntityActionHelpers';

export const DataAlertEditAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editDataAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return FeatureFlags.suspendDataAlerts ? !isAlertSuspended(targetItems) : targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[], state: AppState) => {
    return isEditOrResumeEnabled(state, targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertEdit(targetItems)
};
